import {gql} from '@apollo/client/core';

export const CartImageFragment = gql`
    fragment CartImageFragment on CartImage {
        id
        imageType
        imagePath
    }
`;
